import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Component from './Component';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, data, cart, deletedFromCart, error, message,
  } = state.market;
  return {
    isLoading,
    data,
    cart,
    deletedFromCart,
    error,
    message,
  };
}

const Styled = withStyles(styles)(Component);

export default connect(
  mapStateToProps,
)(Styled);
